import React from 'react';
import PropTypes from 'prop-types';
import HastagIcon from '../icons/HastagIcon';

export default function CategoryName({ name, onFilter, isActive }) {
  return (
    <li>
      <button
        type="button"
        className={`${
          isActive ? 'bg-cyan-200 dark:bg-zinc-700' : ''
        } hover:bg-cyan-100 dark:hover:bg-zinc-600 cursor-pointer px-3 py-2 rounded-md flex w-full`}
        onClick={() => onFilter()}>
        <HastagIcon />
        <span className="pl-2">{name}</span>
      </button>
    </li>
  );
}

CategoryName.propTypes = {
  name: PropTypes.string.isRequired,
  onFilter: PropTypes.func.isRequired,
  isActive: PropTypes.bool.isRequired,
};
